export function headerscroll() {

    const header = document.querySelector('.page-header');
    const headerTop = header.querySelector('.page-header__top');
    const headerMain = header.querySelector('.page-header__main');
    const hero = document.querySelector('.section-hero');
    let scrollBreakpoint = 100;
    let scrollPos = 0;

    window.addEventListener('optimizedScroll', function () {

        if (hero) {
            scrollBreakpoint = (hero.offsetHeight - 50);
        }

        if (headerMain) {
            if (window.scrollY > scrollBreakpoint) {
                header.classList.add('scrolled');
            } else {
                header.classList.remove('scrolled');
            }
        }

        if (headerTop && header) {

            if ((document.body.getBoundingClientRect()).top < scrollPos)
                header.style.transform = 'translateY(-' + headerTop.offsetHeight + 'px)';
            else
                header.style.transform = '';
            // saves the new position for iteration.
            scrollPos = (document.body.getBoundingClientRect()).top;
        }
    });

    return 'headerscroll';

}
